import { NgModule } from '@angular/core';
import { AvatarPlaceholderComponent } from './avatar-placeholder.component';
import { EntityAvatarComponent } from './entity-avatar.component';

/**
 * Legacy convenience module: both avatar components are standalone — import
 * them directly in new code; this module only re-exports them for the many
 * existing consumers.
 */
@NgModule({
  imports: [AvatarPlaceholderComponent, EntityAvatarComponent],
  exports: [AvatarPlaceholderComponent, EntityAvatarComponent],
})
export class AvatarModule {}
